module.exports = __webpack_public_path__ + "media/images/icons/form_venue_step_1-fd8be9e97655d33e907253f5ae715ac5.svg";